<template>
  <div class="page-wrapper">
    <div class="container">
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="container search-content">
              <h2>Search for Club Teams</h2>
            </div>
            <div
              class="dynamic-search-container-club dynamic-search-container-college"
            >
              <div class="mobile-filter">
                <div class="filter-button" @click="showDrawer">
                  <a-icon type="filter" />
                  Filter Table
                </div>
                <a-drawer
                  class="filter-modal menu-modal custom-modal"
                  placement="right"
                  :visible="visible"
                  @close="onClose"
                >
                  <div class="filter-title">
                    Filter Club Search
                  </div>
                  <BaseFilter
                    class="collapse-in"
                    :config="searchConfig"
                    @on-filter-change="handleFilterChange"
                    @submit="handleApplyFilter"
                    :value="{}"
                  />
                </a-drawer>
              </div>
              <BaseFilter
                class="collapse-in"
                :config="searchConfig"
                @on-filter-change="handleFilterChange"
                @submit="handleApplyFilter"
                :value="{}"
              />
            </div>
            <BaseTable
              :columns="columns"
              :data="clubs"
              :pagination="paginationOptions"
              @change="handleTableChange"
              :loading="clubsLoading"
              :show-zero="clubsMeta.total === 0"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Club } from "@/models";
import { CLUB_INDEX_TABLE_COLUMNS } from "@/utils/columns";
import generateImageUrl from "@/utils/generate-image-url";
import { mapGetters } from "vuex";

const STORE_KEY = "clubStore";
const FAVOURITE_STORE_KEY = "favouriteStore";

export default {
  data() {
    return {
      ageGroup: Club.ageGroup(),
      searchConfig: Club.filterConfig(),
      searchFilters: {},
      visible: false,
      currentPage: 1
    };
  },
  mounted() {
    this.getClubs();
  },
  computed: {
    ...mapGetters({
      clubs: `${STORE_KEY}/clubs`,
      clubsMeta: `${STORE_KEY}/clubsMeta`,
      clubsLoading: `${STORE_KEY}/clubsLoading`
    }),
    columns() {
      return [
        {
          title: "Fav",
          dataIndex: "favourite",
          // text, rowdata, index
          customRender: (_text, rowData) => {
            const h = this.$createElement;
            const className = rowData.favC ? "icon-filled" : "";
            const iconTheme = rowData.favC ? "filled" : "outlined";
            return (
              <BaseButton
                type="link"
                class={className}
                on-click={event => this.handleFavouriteClick(event, rowData)}
              >
                <BaseIcon type="star" theme={iconTheme} />
              </BaseButton>
            );
          }
        },
        {
          title: "Club Name",
          dataIndex: "clubName",
          customRender: (_text, rowData) => {
            const h = this.$createElement;
            return (
              <a
                href={this.hrefRoute(rowData.id)}
                target="_blank"
                class="text-black d-flex align-center"
                on-click={ event => this.handlClubCLick(event, rowData) }
              >
                <BaseImageWrapper
                  class="margin-r-10"
                  size={45}
                  imageUrl={generateImageUrl(rowData.logo)}
                  wrapperStyle="circle"
                  name={rowData.clubName}
                />
                {rowData.clubName}
              </a>
            );
          }
        },
        ...CLUB_INDEX_TABLE_COLUMNS
      ];
    },
    paginationOptions() {
      return {
        total: this.clubsMeta.total || 40,
        current: this.currentPage || 1,
        simple: true,
        pageSize:40
      };
    },
    profileId() {
      return Club.profileId();
    }
  },
  methods: {
    hrefRoute(id) {
      return `/${this.profileId}/club_profile/${id}/summary`;
    },
    getClubs(page = 1) {
      this.currentPage = page;
      this.$store.dispatch(`${STORE_KEY}/getClubs`, {
        fields: "state,clubName,age,city,logo",
        sort: "clubName",
        limit: 40,
        ...this.searchFilters,
        page: this.currentPage
      });
    },
    toggleSearchContainer() {
      this.showAdvancedFilters = !this.showAdvancedFilters;
    },
    handleTableChange(paginationData) {
      this.getClubs(paginationData.current);
    },
    goToRoute(route) {
      this.$router.push(route);
    },
    handleFilterChange(searchFilters) {
      this.searchFilters = { ...searchFilters };
    },
    async handleFavourite(rowData){
      if (rowData.favC) {
        await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/deleteFavourite`, {
          favBy: Club.profileId(),
          favTo: rowData.Id
        });
        this.$store.dispatch(`${STORE_KEY}/unsetFavourite`, rowData.Id);
        return;
      }
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/createFavourite`, {
        favBy: Club.profileId(),
        favTo: rowData.Id,
        typeFav: "clubTeam"
      });
      this.$store.dispatch(`${STORE_KEY}/setFavourite`, rowData.Id);

    },
    async handleFavouriteClick(event, rowData) {
      event.stopImmediatePropagation();
      const local_profile_id = localStorage.getItem("profile-id");
      const route_profile_id = this.$route.params.profileId;
      const currentUser = localStorage.getItem("user-permissions");
      if(currentUser === '"player"'){
        this.handleFavourite(rowData);
      }else{
        if(local_profile_id === route_profile_id){
          this.handleFavourite(rowData);
        }else{
           this.$notification.error({
              message: "Error",
              description:"Favourite Error"
            });
        }
      }
    },
    async handlClubCLick(e, rowData) {
      e.stopImmediatePropagation()
      await this.$store.dispatch(`${STORE_KEY}/updateViewCount`, { id: rowData.id })
    },
    handleApplyFilter() {
      this.getClubs();
      this.visible = false;
    },

    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    handleOk(e) {
      this.visible = false;
    }
  }
};
</script>

<style lang="sass">
.text-black
  color: black
.dynamic-search-container-club
  form
    display: grid
    grid-template-columns: repeat(11, 1fr)
    .ant-form-item
      margin-bottom: 5px
    .grid-component
      padding-right: 10px
    .grid-component-wrapper-one
      grid-column-start: 1
      grid-row-start: 1
      grid-column-end: 3
      width: 95%
    .grid-component-wrapper-two
      grid-column-start: 3
      grid-column-end: 5
      grid-row-start: 1
    .grid-component-wrapper-three
      grid-column-start: 5
      grid-column-end: 7
      grid-row-start: 1
    .grid-component-wrapper-four
      grid-column-start: 7
      grid-column-end: 8
      grid-row-start: 1
</style>
